import { HostBinding } from '@angular/core';

export abstract class AbstractModal {
  @HostBinding('class.modal-wrapper')
  public modalClass = true;

  @HostBinding('class.overflow-visible')
  public overflowVisible = false;
}
